var CheckpointState = {
  COMPLIANT: 0,
  NOT_COMPLIANT: 1,
  NOT_APPLICABLE: 2,
};

module.exports = CheckpointState;
